// extracted by mini-css-extract-plugin
export default {"color":"fd0b78","color--grey":"f50291","ebay":"ea2003","ebay__message":"cefc2c","ebay__notice":"e3b599","ebay__button":"df7225","ebay__button-icon":"a5b868"};